<script setup lang="ts">
import type { Component } from 'vue'
import TableRowAccordeonElementalsList from '~~/src/components/Library/TableLibrary/TableRowAccordeonElementalsList/index.vue'
import Footer from '~~/src/components/Elemental/ElementalHeaderInfos/index.vue'
import { useElementalListsStore } from '~~/src/stores/useElementalListsStore'
import type { Elemental, ElementalTypeEnum } from '~~/src/types/elemental'
import type { List } from '~~/src/types/list'
import IconBox from '~~/src/components/DrawerSidebarRight/components/shared/IconBox.vue'
import { ElementalListContext } from '~~/src/components/DrawerSidebarRight/components/shared/ElementalList/ElementalListContext'
import TableRowElementalItem from '~~/src/components/Library/TableLibrary/TableRowElementalItem/index.vue'
import TableRowDynamic from '~~/src/components/Library/TableLibrary/TableRowDynamic/index.vue'

const props = defineProps<{
  list: Elemental | List
  title: string
  elementals?: Elemental[] | null
  elementalsType: ElementalTypeEnum
  iconComponent?: Component
  level?: number
  columns: string[]
}>()

const user = useUser()
const typeList = getElementalTypeRoute(props.elementalsType)

const listId = typeList
const isOwner = computed(() => {
  return user.value?.id === props.list.user.id
})

const { state } = useElementalListsStore()

const elemetalsFiltred = computed(
  () => {
    if (!props.elementals)
      return props.elementals
    if (!state.query || state.query === '')
      return props.elementals
    return props.elementals.filter(items =>
      items.title.toLowerCase().includes(state.query.toLowerCase())
      || items.id.toString().toLowerCase().includes(state.query.toLowerCase()),
    )
  },
)

watch(elemetalsFiltred, (data) => {
  if (data && state.viewsActives?.[props.elementalsType])
  // @ts-expect-error valid
    state.viewsActives[props.elementalsType].count = data?.length
}, { immediate: true })

const showList = computed(() => state.query === '' || (elemetalsFiltred.value && elemetalsFiltred.value?.length > 0) || props.list.title.toLowerCase().includes(state.query.toLowerCase()))

provide(ElementalListContext, {
  listId,
  onList: true,
  isOwner,
  isFolder: false,
  isAll: true,
})
</script>

<template>
  <TableRowAccordeonElementalsList
    v-show="showList" :list="{
      ...props.list,
      id: `all-${listId}`,
    }"
    :list-id="listId"
    :is-main="true"
    list-title="Ungrouped"
    :n-prompts="elemetalsFiltred ? elemetalsFiltred.length : list.nPrompts ?? 0" :elementals-type="elementalsType"
    class="aria-expanded:border-1 border-gray-2"
    :parent-list-id="listId"
    :is-static="true"
    :folder-level="3"
  >
    <template #header>
      <TableRowDynamic
        :is-main="true"
        :list="{
          ...list,
          id: `all-${listId}`,
          title: 'Ungrouped',
        }"
        :folder-level="1"
        :columns="['title']"
        :class="[`level-${2}`]"
        :elemental-label="title"
        class="w-full border-b border-grayLighter"
      >
        <template #list-icon>
          <IconBox class="h-7 w-7 flex-shrink-0 !p-0">
            <IconFolder />
          </IconBox>
        </template>
      </TableRowDynamic>
    </template>
    <template #content>
      <div v-if="elemetalsFiltred && elemetalsFiltred.length > 0">
        <template v-for="(item) in elemetalsFiltred" :key="`${item.id}-${index}-${props.label}`">
          <TableRowElementalItem
            :elemental="item"
            :elemental-label="title"
            :columns="props.columns"
            :folder-level="2"
          />
        </template>
      </div>
      <div v-else class="text-darkGray text-sm text-center p-4  border-1 border-grayLighter rounded-lg">
        no items
      </div>
    </template>
    <template #footer>
      <Footer :elemental="list" :elemetals-filtred="elemetalsFiltred" />
    </template>
  </TableRowAccordeonElementalsList>
</template>
